import React from "react";
import { Line } from "react-chartjs-2";

const ExpenseAreaChart = ({ total = 0, graph = [] }) => {
  const labels = graph.map((item) =>
    new Date(item.date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    }),
  );

  const counts = graph.map((item) => item.count);

  const data = {
    labels,
    datasets: [
      {
        data: counts,
        borderColor: "#198754",
        backgroundColor: "rgba(25,135,84,0.10)",
        fill: true,
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
        pointBackgroundColor: "#198754",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 6,
        },
      },
      y: {
        display: false,
        beginAtZero: true,
        grid: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };

  // Width based on number of points
  const chartWidth = Math.max(graph.length * 45, 350);

  return (
    <div style={{ position: "relative" }}>
      {/* Total - Absolute */}
      <div
        style={{
          position: "absolute",
          // top: "5px",
          left: "10px",
          zIndex: 10,
        }}
      >
        <div
          style={{
            color: "#6c757d",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          Total
        </div>

        <h4
          style={{
            color: "#198754",
            fontWeight: "700",
            margin: 0,
          }}
        >
          {total}
        </h4>
      </div>

      {/* Chart */}
      <div
        style={{
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        <div
          style={{
            width: `${chartWidth}px`,
            height: "180px",
          }}
        >
          <Line data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default ExpenseAreaChart;
